/**
 * 充值规则
 */
import React, { PureComponent } from 'react';
import styles from './index.module.scss';
import { XOKButton, showConfirm } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import CECModal from './modal/CECModal';
import model from '@/reducers/system/operatingrule/model';
class TopUpRules extends PureComponent {

    state = {
        currentOpenMode: false, //渲染弹框
        openModeParam: {}, // 当前需要打开的弹窗的入参
    }

    static propTypes = {
        history: PropTypes.object, // 路由history对象
        getTopUpRules: PropTypes.func,
        topUpRules: PropTypes.array,
    }

    static defaultProps = {
        topUpRules: []
    }

    // 查询触发
    _searchHandle = () => {
        this.searchCache = {};
        this.props.getTopUpRules(this.searchCache);
        KeepAlive.saveCache(this.searchCache); // 【第3步，缓存查询状态】
    }

    //请求函数
    _request = (url, data, tip) => {
        http(url, data, 'POST')
            .then(() => {
                message.success(tip);
                this._searchHandle('useCache');
            })
            .catch(res => {
                message.warn(res.message);
            });
    }

    // 表格操作
    _tableAction = (type, item) => {
        switch (type) {
            case 'edit':
                this.setState({ currentOpenMode: 'edit', openModeParam: item });
                break;
            case 'delete'://删除
                showConfirm('您确定要删除吗？', '', () => {
                    this._request('/?cmd=com.xqxc.api.pig.mis.biz.platform.RechargeRuleMisService.deleteRule', { id: item.id }, '删除操作成功');
                }, () => { });
                break;
            case 'termination'://终止
                showConfirm('终止', '根据当前的规则，已有记录满足当前的规则，需要按规则执行处理么？', () => {
                    this._request('/?cmd=com.xqxc.api.pig.mis.biz.platform.RechargeRuleMisService.stopRule', { id: item.id }, '终止操作成功');
                }, () => { }, '终止，不处理', '终止，且按规则处理');
                break;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: false, openModeParam: {} });
        if (status) {
            this._searchHandle('useCache');
        }
    }

    render() {
        const { currentOpenMode, openModeParam } = this.state;
        return (
            <KeepAlive id='6' render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <XOKButton
                        style={{ width: '100px' }}
                        label='新建规则'
                        onClick={() => this.setState({
                            currentOpenMode: 'edit',
                            openModeParam: { title: '新建规则', url: '/?cmd=com.xqxc.api.pig.mis.biz.platform.RechargeRuleMisService.addRule', tip: '新建规则操作成功' }
                        })}
                    />
                    <TableContent
                        renderData={this.props.topUpRules}
                        tableAction={this._tableAction}
                    />
                    {
                        currentOpenMode &&
                        <CECModal data={openModeParam} closeMode={this._closeMode} />
                    }
                </div>
            </KeepAlive>
        );
    }
}

export default connect(state => ({
    topUpRules: state.operatingrule.topUpRules,
}), model.actions)(TopUpRules);
